'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIList from 'UIComponents/list/UIList';
import withModalProps from 'ContentEditorUI/containers/withModalProps';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { userInfoSync } from 'hub-http/userInfo';
import { getSaveError } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { reloadWithoutWarning } from 'ContentEditorUI/redux/actions/appActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  error: getSaveError(state)
});
const mapDispatchToProps = {
  reload: reloadWithoutWarning
};
class LockedModal extends Component {
  constructor(...args) {
    super(...args);
    this.handleReload = () => {
      this.props.reload();
    };
  }
  getErrorUserName() {
    const {
      error
    } = this.props;
    return error.updatedUserName;
  }
  isSameUser() {
    return userInfoSync().user.email === this.getErrorUserName();
  }
  render() {
    const {
      onClose,
      contentNounKey
    } = this.props;
    const isSameUser = this.isSameUser();
    const errorUser = this.getErrorUserName();
    const lockedTypeKey = isSameUser ? 'sameUser' : 'otherUser';
    return /*#__PURE__*/_jsxs(UIModal, {
      className: 'locked-modal',
      "data-test-id": "locked-modal",
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'lockedModal.heading'
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `lockedModal.${lockedTypeKey}`,
            options: {
              user: errorUser,
              contentType: I18n.text(contentNounKey)
            }
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'lockedModal.instructions1'
          })
        }), /*#__PURE__*/_jsxs(UIList, {
          styled: true,
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.instructions2'
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.instructions3'
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.instructions4'
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.instructions5'
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        align: 'center',
        children: [/*#__PURE__*/_jsx(UIButton, {
          className: 'large m-bottom-4',
          use: "primary",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'lockedModal.primaryButtonText'
          })
        }), /*#__PURE__*/_jsxs("p", {
          className: 'm-left-0',
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: 'lockedModal.footer'
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "link",
            onClick: this.handleReload,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.secondaryButtonText'
            })
          })]
        })]
      })]
    });
  }
}
LockedModal.propTypes = {
  error: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
  contentNounKey: PropTypes.string.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(withModalProps(LockedModal, MODAL_TYPES.LOCKED_MODAL));